import Const from '../util/Constants';
import RegEx from '../util/RegEx';

class ValidationController {

  static result = (key, inValid) => {
    let tmpValid = inValid === null ? {} : inValid;
    tmpValid[key] = 'Invalid Data';
    return tmpValid;
  }
  
  static validate = (fields, object) => {
    const keys = Object.keys(fields);
    let inValid = null;
    for(let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const editable = fields[key].editable;
      const type = fields[key].field_type;
      const mandatory = fields[key].form_mandate;
      const validate = fields[key].validate;
      if(!editable || type === Const.Model
        || key === 'created_by'|| key === 'created_date'
        || key === 'updated_by'|| key === 'updated_date' || key === 'id') continue;

      if (type === Const.Address) {
        if(mandatory && object[key].length === 0) inValid = ValidationController.result(key, inValid);
        let i = 0;
        let notEmpty = 0;
        for(; i < object[key].length; i++) {
          const address = object[key][i];
          if(address.street.trim() !== '' || parseInt(address.city) !== 0
            || parseInt(address.state) !== 0 || parseInt(address.country) !== 0
            || address.pin.trim() !== '') notEmpty++;
        }
        if(mandatory && notEmpty === 0) inValid = ValidationController.result(key, inValid);
      } else if (type === Const.SinglePhone) {
        if(mandatory && (object[key] === '' || object[key] === '~~'))
          inValid = ValidationController.result(key, inValid);
         continue;
      } else if (type === Const.MultiValue || type === Const.Phone || type === Const.Email) {
        if(mandatory && (object[key] === '' || object[key] === '~~')) {
          inValid = ValidationController.result(key, inValid);
        }
        /*
        const regex = JSON.parse(validate);
        if(object[key].length === 0 || !RegEx.isMatch(object[key][0].street, false, regex.street))
          inValid = ValidationController.result(Const.Street, inValid);
        if(object[key].length === 0 || !RegEx.isMatch(object[key][0].city, false, regex.city))
          inValid = ValidationController.result(Const.City, inValid);
        if(object[key].length === 0 || !RegEx.isMatch(object[key][0].state, false, regex.state))
          inValid = ValidationController.result(Const.State, inValid);
        if(object[key].length === 0 || !RegEx.isMatch(object[key][0].country, false, regex.country))
          inValid = ValidationController.result(Const.Country, inValid);
        if(object[key].length === 0 || !RegEx.isMatch(object[key][0].pin, false, regex.pin))
          inValid = ValidationController.result(Const.Pin, false, inValid);
          */
         continue;
      } else if (type.includes(Const.MultiSelect)) {
        if(validate.includes('multi') && validate.includes('false')) {
          const tmp = object[key] && object[key].length > 2 ? object[key].substring(1, object[key].length - 1).split('~'):[];
          if(tmp && tmp.length > 1) {
            inValid = ValidationController.result(key, inValid);
          }
        } else if(mandatory && (object[key] === '' || object[key] === '~~')) {
          inValid = ValidationController.result(key, inValid);
        }
      } else {
        if(!RegEx.isMatch(object[key], mandatory, validate)) {
          inValid = ValidationController.result(key, inValid);
        }
      }
    }
    return inValid;
  }
}
export default ValidationController;